__turbopack_context__.v({
  "action": "style-module-scss-module__z7igvG__action",
  "btn": "style-module-scss-module__z7igvG__btn",
  "content": "style-module-scss-module__z7igvG__content",
  "content_hidden": "style-module-scss-module__z7igvG__content_hidden",
  "faq": "style-module-scss-module__z7igvG__faq",
  "title": "style-module-scss-module__z7igvG__title",
  "wrapper": "style-module-scss-module__z7igvG__wrapper",
});
